import { Avatar, AvatarSizeVariant, SkeletonLoader } from '@payaca/ambrosia';
import { useParams } from 'react-router';
import useGetChildAccount from '../../../api/queries/childAccounts/useGetChildAccount';

const ChildAccountPageHeaders = () => {
  const { accountId } = useParams<{ accountId: string }>();
  const { data: childAccount, isLoading } = useGetChildAccount(accountId);

  return (
    <div>
      <div
        className="w-full h-40 rounded-xl"
        style={{ background: childAccount?.branding.logoUrl || undefined }}
      />
      <div className="flex flex-col items-center justify-items-center -mt-24">
        {!childAccount ? (
          <>
            <SkeletonLoader.Circle className="w-16 h-16" />
            <SkeletonLoader.Title className="w-1/6 mt-2" />
          </>
        ) : (
          <div className="flex flex-col items-center">
            {isLoading ? (
              <SkeletonLoader.Circle className="w-16 h-16" />
            ) : (
              <>
                <div>
                  <Avatar
                    imgSrc={childAccount.branding.logoUrl || ''}
                    sizeVariant={AvatarSizeVariant.LG}
                    imgDescription={`Logo for ${childAccount.name}`}
                    iconName="building-01.3"
                  />
                </div>

                <h1 className="mt-2">{childAccount.name}</h1>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChildAccountPageHeaders;
